module.exports = __webpack_public_path__ + "static/img/rule_color.a3dd2e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/email/signature/rule_color.png
// module id = 116
// module chunks = 1